export default __webpack_public_path__ + "static/media/seasonal-1.e5bc3b62.jpg";